// extracted by mini-css-extract-plugin
module.exports = {"NumberedList":"styles_NumberedList__K_m_C","bg_1":"styles_bg_1__eNEGt","height":"styles_height__e6107"};